import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { SegovPage } from 'src/app/app.routes';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { ControlsModule } from 'segov-sigepo-lib';
import { ComunicadoOutputDto } from 'src/app/domain/DTOs/output/comunicado.output.dto';
import { ComponentMessages } from 'src/app/utils/component.messages';
import { ListarComunicadosState } from 'src/app/stateManagement/reducers/listar-comunicados.reducer';
import { Store } from '@ngrx/store';
import { filter, Subscription } from 'rxjs';
import { selectDadosListarComunicados } from 'src/app/stateManagement/selectors/listar-comunicados.selector';
import { listarComunicados, listarComunicadosFinish } from 'src/app/stateManagement/actions/listar-comunicados.action';
import { ListarComunicadosInputDto } from 'src/app/domain/DTOs/input/listar-comunicados.input.dto';
import { CommonMessages } from 'src/app/utils/common.messages';

@Component({
  selector: 'app-comunicados-page',
  standalone: true,
  imports: [
    SegovSigepoPortalBodyComponent,
    SegovSigepoHeaderSectionComponent,
    ControlsModule
  ],
  templateUrl: './comunicados-page.component.html',
  styleUrl: './comunicados-page.component.css'
})
export class ComunicadosPageComponent implements OnInit, OnDestroy {
  public title = ComponentMessages.centralDeRelacionamento;
  public errorMsg = '';

  private InputPesquisa = '';
  private subListarComunicados: Subscription;

  public PaginaAtual = 1;
  public TotalPaginas = 1;
  public TotalRegistrosPorPagina = 3;

  public apagarTexto = new EventEmitter<void>();
  public efetouPesquisa = false;
  public reiniciouPesquisa = false;

  public ComunicadosOutputDto: ComunicadoOutputDto[] = [];
  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "Atendimento", route: SegovPage.Comunicados},
    { title: "Comunicados", route: SegovPage.Comunicados }
  ];

  constructor(private readonly storeListarComunicados: Store<{ listarComunicadosState: ListarComunicadosState }>) {
    this.subListarComunicados = new Subscription();
  }

  ngOnInit(): void {
    this.subListarComunicados = this.storeListarComunicados.select(selectDadosListarComunicados)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.ComunicadosOutputDto = response?.dados ? this.ComunicadosOutputDto.concat(response.dados) : [];
        this.PaginaAtual = response?.paginaAtual ?? 1;
        this.TotalPaginas = response?.totalDePaginas ?? 1;

        if(this.InputPesquisa)
          this.efetouPesquisa = true;
        if(this.reiniciouPesquisa)
          this.efetouPesquisa = false;
      });

    this.getListarComunidados(new ListarComunicadosInputDto('', 1, this.TotalRegistrosPorPagina));
  }

  ngOnDestroy(): void {
    this.subListarComunicados.unsubscribe();
    this.storeListarComunicados.dispatch(listarComunicadosFinish());
  }


  public AtualizaTexto(event: string) {
    if (event.length < 3 && event.length > 0) {
      this.errorMsg = CommonMessages.LimiteMinimoPesquisa;
    } else {
      this.errorMsg = '';
    }
    this.InputPesquisa = event;
  }

  public ListarComunicadosPesquisa() {
    this.reiniciouPesquisa = false;
    if (!this.errorMsg && this.InputPesquisa.length > 2) {
      this.ComunicadosOutputDto = [];
      this.PaginaAtual = 1;
      this.getListarComunidados(new ListarComunicadosInputDto(this.InputPesquisa, this.PaginaAtual, this.TotalRegistrosPorPagina));
    }
  }

  public CarregarMaisComunicados() {
    this.reiniciouPesquisa = false;
    this.PaginaAtual += 1;
    this.getListarComunidados(new ListarComunicadosInputDto(this.InputPesquisa, this.PaginaAtual, this.TotalRegistrosPorPagina));
  }

  public ReiniciarPesquisa() {
    this.reiniciouPesquisa = true;
    this.ComunicadosOutputDto = [];
    this.PaginaAtual = 1;
    this.getListarComunidados(new ListarComunicadosInputDto('', this.PaginaAtual, this.TotalRegistrosPorPagina));
    this.InputPesquisa = '';
    this.errorMsg = '';
    this.apagarTexto.emit();
  }

  private getListarComunidados(inputDto: ListarComunicadosInputDto) {
    this.efetouPesquisa = false;
    this.storeListarComunicados.dispatch(listarComunicados({ listarComunicadosInputDto: inputDto }))
  }
}
